<template>
  <CRow>
    <img
        src="../../../public/img/avatars/preika_title.png"
        style="width: 100%;
        max-width: 900px;
        padding-bottom: 10px;"
      />
    <CRow>
      <CRow class="justify-content-start" 
      style="padding-right: 25px
      ;padding-left: 25px"
      >
        <CCol sm="15" lg="3">
          <CCard
            style="width: 415px; height: 225px; color: white"
            color="primary"
            class="card-body pb-3"
          >
            <CCardHeader>
              <div style="display: flex; align-items: center; margin-left: 30px; column-gap: 2rem; font-size: 20px; font-weight: bold;">
                <span>打刻</span>
                <span>{{ today[0] }}</span>
              </div>
            </CCardHeader>

            <CCardBody style="font-size: 15px">
              <save-button
                :label="'出勤'"
                :loading="loading"
                @click="handleTime('start')"
                class="btn btn-success"
              />
              <save-button
                :label="'退勤'"
                :loading="loading"
                @click="handleTime('end')"
                class="btn btn-info"
              />
              <save-button
                :label="'休憩開始'"
                :loading="loading"
                :disabled="useProjectBreakFlg"
                @click="handleTime('breakStart')"
                class="btn btn-danger"
              />
              <save-button
                :label="'休憩終了'"
                :loading="loading"
                :disabled="useProjectBreakFlg"
                @click="handleTime('breakEnd')"
                class="btn btn-warning"
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow class="justify-content-start" 
      style="padding-right: 25px
      ;padding-left: 25px"
      >
        <CCol sm="15" lg="3">
          <CCard
            style="width: 415px; height: 225px; color: white"
            color="info"
            class="card-body pb-3"
          >
            <CCardHeader>
              <strong style="font-size: 20px; font-weight: bold">
                お知らせ
              </strong>
            </CCardHeader>
            <CCardBody style="font-size: 15px">
              月次提出期間中以外は予告なしにメンテナンスを実施しておりますのでご了承下さい。<br/><br/>
              2025/09/10【update】各種申請でステータスが分かるよう改善<br/>
              2025/09/10【update】休暇連絡先入力を任意に変更
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CRow>
    <CRow>
      <CRow class="justify-content-start" 
      style="padding-right: 25px
      ;padding-left: 25px"
      >
        <CCol sm="15" lg="3">
          <CCard
            style="width: 415px; height: 225px; color: white"
            color="success"
            class="card-body pb-3"
          >
            <CCardHeader>
              <strong style="font-size: 20px; font-weight: bold">
                月次提出
              </strong>
            </CCardHeader>
            <CCardBody style="font-size: 15px">
              <b>【勤務表】【業務報告】<br/>【通勤費】【経費】</b><br />
              第2営業日までに提出をお願いします。申請差戻により修正が必要な場合は間接業務に影響しますので早めの再提出をお願いします。
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow class="justify-content-start" 
      style="padding-right: 25px
      ;padding-left: 25px"
      >
        <CCol sm="15" lg="3">
          <CCard
            style="width: 415px; height: 225px; color: white"
            color="warning"
            class="card-body pb-3"
          >
            <CCardHeader>
              <strong style="font-size: 20px; font-weight: bold">
                随時提出
              </strong>
            </CCardHeader>
            <CCardBody style="font-size: 15px">
              <b>【有休】【代休】【特休】<br />【予定外時間外】【休日出勤】</b
              ><br />
              わかり次第早めの提出をお願いします。発生前日までに提出が出来ない場合は上長に直接連絡の上、後日改めて提出をお願いします。
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CRow>
    <iframe src="https://www.sunny-spot.net/get_fcst/parts_week.php?ID=408280&CL=BLUE" 
      width="890px" 
      height="130" 
      hspace="0" vspace="0" marginheight="0" marginwidth="0" frameborder="0" scrolling=no>
    </iframe>
    <iframe
      src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Asia%2FTokyo&bgcolor=%23ffffff&src=YWtpLWNvcnAuY29tXzFtdDllbjlrbWRvMTlicGM0azV2NXNhZzY0QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&src=amEuamFwYW5lc2UjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23D50000&color=%230B8043"
      style="border: solid 1px #777"
      width="890px"
      height="600px"
      frameborder="0"
      scrolling="no">
    </iframe>
  </CRow>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConstList from "./../../ConstList";
import SaveButton from '../../common/SaveButton';

export default {
  name: "WidgetsDropdown",
  components: { SaveButton },
  data() {
    return {
      today: [],
      startTime: "",
      endTime: "",
      brakeStartTime: "",
      brakeEndTime: "",
      useProjectBreakFlg: true,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  methods: {
    setDate: function () {
      this.today.splice(0, 1, new Date().toLocaleString());
    },
    handleTime(type) {
      const now = moment(this.today[0], "YYYY/M/D H:mm").format("YYYY/MM/DD HH:mm");
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.loading = true;
      switch (type) {
        case "start":
          this.startTime = now;
          console.log("出勤:", this.startTime);
          break;
        case "end":
          this.endTime = now;
          console.log("退勤:", this.endTime);
          break;
        case "breakStart":
          console.log("休憩開始:", this.brakeStartTime);
          break;
        case "breakEnd":
          this.brakeEndTime = now;
          console.log("休憩終了:", this.brakeEndTime);
          break;
        }
        this.submit_flg = true;
        let data = {
          button_type: type,
          timestamp: now
          };
        if (type === "breakEnd") {
          data.brakeStartTime = this.brakeStartTime;
        }
        if(type !== "breakStart"){
        axios.post(process.env.VUE_APP_API_ORIGIN + "/stamping/update", data)
        .then(res => {
          console.log("送信成功:", res.data);
          alert(ConstList.SUCCESS_STAMPING);
        })
        .catch(err => {
          this.submit_flg = false;
          console.error("送信失敗:", err);
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        })
        .finally(() => {
        // 必ず解除
        this.submit_flg = false;
        this.loading = false;
      });
    } else {
      // 休憩開始ボタンの場合は即座にフラグを解除
      this.submit_flg = false;
      this.loading = false;
    }
  }
  },

  mounted: function () {
    this.setDate();
    setInterval(() => this.setDate(), 1000);

    // use_project_break_flg を取得
    axios.get(process.env.VUE_APP_API_ORIGIN + "/stamping/initial")
    .then(res => {
      this.useProjectBreakFlg = res.data;
      console.log("休憩自動設定フラグ取得:", this.useProjectBreakFlg);
    })
    .catch(err => {
      console.error("フラグ取得失敗:", err);
    });
  },
};
</script>

<style scoped>
.iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>